import { PlusOutlined } from '@ant-design/icons';
import { Button, Drawer, PageHeader, Tabs } from 'antd';
import React from 'react';
import { defaultTablePagination, DRAWER_WIDTH } from '../../config/constants';
import Routes from '../../config/routes';
import { translations } from '../../config/translations';
import { ActionType, DrawerState, ModuleName } from '../../core/models/enum';
import { authorizeAction } from '../../helpers/CheckPermissionHelper';
import { ToolTransferDetailVm } from '../../utils/api';
import TransferForm from './transfer-form/TransferForm';
import TransferTable from './transfer-table';
import { Props } from './index';

interface State {
    allowCreate: boolean;
    drawerState: DrawerState;
}

class Transfers extends React.Component<Props, State> {
    private tableRef: any = React.createRef();

    public constructor(props: Props) {
        super(props);

        const {
            match: { path },
        } = props;

        this.state = {
            allowCreate: authorizeAction(props.userProfile, ModuleName.Transfers, ActionType.Create),
            drawerState: path === Routes.ROUTE_TRANSFERS_NEW ? DrawerState.Create : DrawerState.Closed,
        };
    }

    private handleDrawerMode = (drawerState: DrawerState) => {
        const { history } = this.props;

        this.setState({
            drawerState,
        });

        history.push(
            drawerState === DrawerState.Create ? Routes.ROUTE_TRANSFERS_NEW : Routes.ROUTE_TRANSFERS
        );
    };

    private handleSuccessCreate = (_: ToolTransferDetailVm) => {
        this.handleDrawerMode(DrawerState.Closed);
        this.tableRef.current.getTransfers(defaultTablePagination);
    };

    private handleTabChange = async (activeKey: string) => {
        const { history, location } = this.props;
        const params = new URLSearchParams(location.search);

        if (params.has('activeTab')) {
            params.set('activeTab', activeKey);
        } else {
            params.append('activeTab', activeKey);
        }

        history.push({
            pathname: history.location.pathname,
            search: params.toString(),
        });
    };

    public render(): React.ReactElement {
        const { drawerState, allowCreate } = this.state;
        const { location } = this.props;
        const params = new URLSearchParams(location.search);
        const activeTab = params.get('activeTab') ? params.get('activeTab') : 'active';

        return (
            <>
                <PageHeader
                    title={translations.transfers.transfers}
                    extra={
                        allowCreate
                            ? [
                                  <Button
                                      key="1"
                                      type="primary"
                                      style={{
                                          zIndex: 10,
                                          float: 'right',
                                      }}
                                      onClick={() => this.handleDrawerMode(DrawerState.Create)}
                                      className="no-print"
                                  >
                                      <PlusOutlined />
                                      {translations.transfers.addTransfer}
                                  </Button>,
                              ]
                            : []
                    }
                >
                    <Tabs
                        type="editable-card"
                        activeKey={activeTab || 'active'}
                        onTabClick={(key: string) => this.handleTabChange(key)}
                        hideAdd
                        destroyInactiveTabPane={true}
                        items={[
                            {
                                label: translations.transfers.activeTab,
                                key: 'active',
                                closable: false,
                            },
                            {
                                label: translations.transfers.completedTab,
                                key: 'completed',
                                closable: false,
                            },
                        ]}
                    />
                </PageHeader>

                <TransferTable wrappedComponentRef={this.tableRef} />

                <Drawer
                    title={translations.transfers.addTransfer}
                    open={!!drawerState}
                    onClose={() => this.handleDrawerMode(DrawerState.Closed)}
                    width={DRAWER_WIDTH}
                    destroyOnClose
                >
                    <TransferForm
                        onClose={() => this.handleDrawerMode(DrawerState.Closed)}
                        onSuccess={this.handleSuccessCreate}
                    />
                </Drawer>
            </>
        );
    }
}

export default Transfers;
